import React from "react";
import styled from "styled-components/macro";
import { rem } from "polished";

import processHelpText, { ProcessedHelpText } from "../helpers/processHelpText";
import Info from "./Info";
import ReactMarkdown from "react-markdown";
import colors from "../theme/colors";

type Props = {
  text: string;
};

const FormNote: React.FunctionComponent<Props> = ({ text }) => {
  const processedText = React.useMemo<ProcessedHelpText | false>(
    () => processHelpText(text),
    [text],
  );

  const noteText = React.useMemo(() => {
    if (typeof text === "string") {
      return (
        <ReactMarkdown
          source={text}
          renderers={{ paragraph: "span" }}
          linkTarget="_blank"
        />
      );
    }
    return text;
  }, [text]);

  if (!text || text === "") {
    return null;
  }

  if (processedText) {
    let { after, before } = processedText;

    return (
      <Note>
        {before && before}
        <Info inherit string="" {...processedText} />
        {after && after}
      </Note>
    );
  }

  return noteText ? <Note>{noteText}</Note> : null;
};

export default FormNote;

export const Note = styled.p`
  color: #585858;
  font-size: ${rem(15)};
  line-height: 1.2;
  margin-bottom: ${rem(15)};
  margin-top: ${rem(-4)};
  font-weight: 300;
  z-index: 1001;

  a {
    color: ${colors.blue};
  }

  strong {
    font-weight: 700;
  }

  ul {
    list-style-type: disc;
    margin-top: 8px;
  }
`;
